import { createSlice } from '@reduxjs/toolkit'
import { TProductFilters } from '../../models'
import reducers from './reducers'

const INITIAL_PRODUCT_FILTERS_STATE: TProductFilters[] = <TProductFilters[]>[]

export const productFiltersSlice = createSlice({
  name: 'productFilters',
  initialState: INITIAL_PRODUCT_FILTERS_STATE,
  reducers: {
    resetProductFilters: () => INITIAL_PRODUCT_FILTERS_STATE,
    ...reducers,
  },
})

export const {
  resetProductFilters,
  setBrands,
  setCategories,
  setSearch,
  setPrice,
  removeBrands,
  removeCategories,
  removePrice,
  removeProductFilters,
} = productFiltersSlice.actions

export const productFiltersReducer = productFiltersSlice.reducer
